function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgA = function SvgA(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 86"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M69.7 85.2H43.4l-1.3-13.3-13.6.3-2 13H.5L15.5.7H57zM8.4 56 21.2 2.8h-3.8zm22 3.4 10.3-1-4.2-40.7zm13.3-1.2 2.2-.3-6.4-38.4z",
    style: {
      fill: "#213867"
    }
  }));
};
export default SvgA;